import * as React from 'react';

import { ActionsDropdown as MooskinActionsDropdown, ActionsDropdownItem, IBoxComponentProps } from '@moosend/mooskin';

interface IActionsDropdownProps {
	show?: boolean;
	arrowBottom?: boolean;
	arrowStyles?: React.CSSProperties;
	onOverlayClick?: () => void;
	background?: string;
	className?: string;
	style?: React.CSSProperties;
	children?: any;
	noOverlay?: boolean;
}

export const ActionsDropdown: React.FC<IActionsDropdownProps> = (props) => {
	return (
		<>
			{props.show && <div style={{ position: 'fixed', top: 0, right: 0, left: 0, bottom: 0, zIndex: 1 }} onClick={props.onOverlayClick} />}
			<MooskinActionsDropdown
				onClose={props.onOverlayClick}
				isOpen={props.show}
				top={[30, 30, 'unset', 'unset']}
				right={[-18, -18, 10, 10]}
				position={['absolute', 'absolute', 'fixed', 'fixed']}
			>
				{props.children}
			</MooskinActionsDropdown>
		</>
	);
};

interface IActionItemProps {
	onClick?: () => void;
	className?: string;
	style?: React.CSSProperties;
	children?: any;
	boxProps?: IBoxComponentProps;
}

export const ActionsItem: React.FC<IActionItemProps> = (props) => {
	const onClick = () => {
		props.onClick && props.onClick();
	};

	return (
		<ActionsDropdownItem onClick={onClick} className={`actions-dropdown-item ${props.className}`} style={props.style} {...props.boxProps}>
			{props.children}
		</ActionsDropdownItem>
	);
};

ActionsDropdown.defaultProps = {
	show: true,
};
